import { useCadStore, load } from "../store/cadStore";

export const BASE_URLS = {
    default: "http://localhost:11434/v1",
    openai: "https://api.openai.com/v1",
    anthropic: "https://api.anthropic.com/v1",
    groq: "https://api.groq.com/openai/v1",
};
export const DEFAULT_MODELS = {
    default: "qwen2.5-coder:7b",
    openai: "gpt-4o",
    anthropic: "claude-sonnet-4-20250514",
    groq: "llama-3.3-70b-versatile",
};

class AIOrchestrator {
    configFor(provider) {
        const s = useCadStore.getState();
        const endpoints = load("roocad_endpoints", {});
        return {
            provider,
            baseUrl: endpoints[provider] || BASE_URLS[provider],
            apiKey: s.apiKeys[provider] || "",
            model: s.apiModels[provider] || DEFAULT_MODELS[provider],
        };
    }

    /* Self-learning: augment system prompt with past user corrections */
    learningMessages(messages) {
        const s = useCadStore.getState();
        const fb = s.aiFeedback || [];
        if (!fb.length) return messages;
        const examples = fb.slice(-10).map((f) => `- Request: "${f.prompt}" → Correction: ${f.correction}`).join("\n");
        const sys = [...messages];
        sys[0] = { ...sys[0], content: `${sys[0].content}\n\nLearned preferences from previous user corrections (always apply these):\n${examples}` };
        return sys;
    }

    /* Try each configured provider in fallback order; first success wins */
    async chat(messages, options = {}) {
        const order = useCadStore.getState().settings.fallbackOrder || ["default"];
        const augmented = this.learningMessages(messages);
        const errors = [];
        for (const provider of order) {
            const cfg = this.configFor(provider);
            try {
                return await this.request(cfg, augmented, options);
            } catch (err) {
                console.warn(`[AI] ${provider} failed, trying fallback…`, err.message);
                errors.push(`${provider}: ${err.message}`);
            }
        }
        throw new Error(`All AI providers failed. ${errors.join(" | ")}`);
    }

    async request(cfg, messages, options) {
        const res = await fetch(`${cfg.baseUrl}/chat/completions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(cfg.apiKey ? { Authorization: `Bearer ${cfg.apiKey}` } : {}),
            },
            body: JSON.stringify({ model: cfg.model, messages, ...options }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
        const data = await res.json();
        const content = data.choices?.[0]?.message?.content;
        if (typeof content !== "string" || !content.trim()) {
            throw new Error(`${cfg.provider} returned an empty response`);
        }
        return content;
    }
}

export const ai = new AIOrchestrator();
